

(() => {
    /* We should not handle the click from the filters menu */
    jQuery('.obfuscated-link:not(.link-dropdown__link)').on('click', function () {
        if (!jQuery(this).data('link'))
            return;

        if(jQuery(this).data('new-page'))
            window.open(jQuery(this).data('link'), '_blank');
        else
            window.location.href = jQuery(this).data('link');
    })
})();